import {
  getBackendAvailabilityUiSnapshot,
  subscribeBackendAvailabilityUi,
} from '@affine/core/utils/backend-availability';

export function getAIChatOnlineStatus() {
  return getBackendAvailabilityUiSnapshot();
}

export function subscribeAIChatOnlineStatus(listener: () => void) {
  return subscribeBackendAvailabilityUi(listener);
}
